import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view04ImageOptions } from './views/exterior_view04'

class XP44BathingPlatform extends Component {

    constructor(props) {
        super(props);
        this.handleBathingPlatformChange = this.handleBathingPlatformChange.bind(this);
    }

    handleBathingPlatformChange(newValue) {
        let configuration = this.props.configuration;
        configuration.BathingPlatform = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view04ImageOptions;

        let image = <ConfiguratorImage boat="XP44" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption>

                    <h1><Trans defaults='Bathing platform' /></h1>
                    
                    <p><Trans defaults='Optional folding bathing transom with manual hoisting and lowering system, with teak, vacuum applied. Bathing ladder in stainless steel to be hooked onto platform when lowered.' /></p>

                    <RadioGroup options={this.props.bathingPlatformOptions} value={this.props.configuration.BathingPlatform} onChange={this.handleBathingPlatformChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XP44BathingPlatform);


// WEBPACK FOOTER //
// ./src/XP44/XP44BathingPlatform.js